import React, { useState, useEffect } from "react";
import {
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    ComposedChart,
} from "recharts";
const monthMap = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
  };

const HHHMByMonth = () => {
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        fetch("https://malaria-api.ddc-malaria.org/mhealth/getChartOverallHHHMToday/fs_year")
            .then((response) => response.json())
            .then((data) => {
                const transformedData = Object.entries(
                    data.overall_hh_hm_status_by_month_fiscal
                ).map(([monthKey, monthData]) => {
                    const { year_month, total_hh_hm_detail } = monthData;
                    const monthYear = monthMap[year_month.slice(4)];

                    const {
                        total_household,
                        total_household_member,
                    } = total_hh_hm_detail;

                    

                    return {
                        month: monthYear,
                        HouseHold: parseInt(total_household, 10),
                        HouseHoldMember: parseInt(total_household_member, 10), // Assuming 'Active' corresponds to 'total_cancel'
                    };
                });

                setChartData(transformedData);
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, []);

    return (
        <div className="plan-status-by-month">
            <h3>Overall Families,and Family Members</h3>
            <ResponsiveContainer width="100%" height={300}>
                <ComposedChart data={chartData} barCategoryGap={50}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                    <YAxis yAxisId="left" tick={{ fontSize: 12 }} /> {/* Add an ID for the left Y-axis */}
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="HouseHold" fill="#0088FE" barSize={40} yAxisId="left"/>
                    <Bar dataKey="HouseHoldMember" fill="#00C49F"barSize={40} yAxisId="left" barGap={20} />
                    
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
};

export default HHHMByMonth;

